<template>
  <normal-dialog
    :title="type ? '编辑' : '新增'"
    :visible="visible"
    :before-close="resetDialog"
    @update:visible="updateVisibleHandle"
    class="ParamsMapsDialog"
  >
    <el-form
      :disabled="loading"
      label-width="100px"
    >
      <el-form-item label="参数名称">
        <el-input
          v-model.trim="selected.name"
          :maxlength="10"
          placeholder="请输入参数名称"
        />
      </el-form-item>
      <el-form-item label="上行控制">
        <el-input
          v-model.trim="selected.cmdCodeUp"
          :maxlength="10"
          placeholder="请输入上行控制"
        />
      </el-form-item>
      <el-form-item label="下行控制">
        <el-input
          v-model.trim="selected.cmdCode"
          :maxlength="10"
          placeholder="请输入下行控制"
        />
      </el-form-item>
      <el-form-item label="参数说明">
        <el-input
          type="textarea"
          v-model.trim="selected.description"
          :rows="3"
          resize="none"
          :maxlength="100"
          placeholder="请输入参数说明"
        />
      </el-form-item>
      <el-form-item label="输入类型">
        <el-select v-model="selected.inputType">
          <el-option
            v-for="(item, index) in inputTypeOptions"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="取值范围"
        v-if="this.selected.inputType == 2"
      >
        <div
          class="valuesRange"
          v-for="(item, index) in selected.valuesRangeArr"
          :key="index"
        >
          <el-input
            class="valuesRange-input"
            v-model.trim="item.key"
            :maxlength="10"
            placeholder="键名"
          />
          <el-input
            class="valuesRange-input"
            v-model.trim="item.value"
            :maxlength="20"
            placeholder="键值"
          />
          <el-button @click="() => delValueRangeKey(index)">-</el-button>
        </div>
        <el-button @click="addValueRangeKey">+</el-button>

      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="resetDialog">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="submitUpdateHandle"
      >确 定</el-button>
    </div>
  </normal-dialog>
</template>

<script>
const dialogMixin = manageShell.default.mixinModule.Dialog;

export default {
  props: {
    inputTypeOptions: { type: Array },
    addValueRangeKey: { type: Function },
    delValueRangeKey: { type: Function },
  },
  mixins: [dialogMixin],
  methods: {
    formatMoney(col, row, val) {
      return (val / 100).toFixed(2);
    },
  },
};
</script>

<style lang="scss">
.ParamsMapsDialog {
  .valuesRange {
    display: flex;
    margin-bottom: 10px;
    .valuesRange-input {
      margin-right: 10px;
    }
  }
}
</style>

